import {Injectable} from '@angular/core';
import {ApiService} from './api/api.service';
import {Checkpoint} from '../classes/checkpoint';
import {RealtimeService} from './realtime/realtime.service';
import {WebsocketService} from './websocket/websocket.service';
import {RealtimeType} from './realtime/realtime-type.enum';
import {CheckpointResult} from '../classes/checkpoint-result';

@Injectable({
    providedIn: 'root'
})
export class CheckpointService extends RealtimeService<Checkpoint> {

    constructor(public apiService: ApiService, protected websocketService: WebsocketService) {
        super(websocketService, RealtimeType.checkpoints);
    }

    getCheckpoint(id: number) {
        return this.apiService.getCallData$<Checkpoint>(`checkpoints/${id}`);
    }

    getCheckpoints(platformId?: number) {
        return this.apiService.getCallData$<Checkpoint[]>(`checkpoints`, platformId ? {platform_id: platformId} : {});
    }

    getCheckpointsLive(platformId?: number) {
        return this.liveList(this.getCheckpoints(platformId), checkpoint => !platformId || +checkpoint.platform_id === +platformId);
    }

    saveCheckpoint(checkpoint: Checkpoint) {
        return this.apiService.postCall$<Checkpoint>('checkpoints', checkpoint);
    }

    deleteCheckpoint(checkpointId: number) {
        return this.apiService.deleteCall(`checkpoints/${checkpointId}`);
    }

    queueImmediately(checkpointId: number) {
        return this.apiService.postCall$<CheckpointResult>('checkpoints/queue/immediately', {checkpoint_id: checkpointId});
    }

    itemInDaterange(planning: Checkpoint, fromDate: Date, toDate: Date) {
        return true;
    }
}
